// components/sections/Scoreboard/Scoreboard.jsx
import React, { useState } from 'react';
import { tabRegistry } from './tabs/registry';
import ScoreboardHeader from './ScoreboardHeader/ScoreboardHeader';
import ScoreboardTabs from './ScoreboardTabs/ScoreboardTabs';
import BannerButtom from './bannerButtom/BannerButtom';
import classes from './Scoreboard.module.css';

const Scoreboard = ({ tabs, houses, banner, defaults, shouldShowHeaderAndTabs,classesList }) => {

  const [activeTabId, setActiveTabId] = useState(defaults.activeTabId);
  const TabComponent = tabRegistry[activeTabId];

  const onTabChange = (tabId) => {
    setActiveTabId(tabId);
  };

  return (
    <div className={classes.scoreboard}>
      {shouldShowHeaderAndTabs &&
        <ScoreboardHeader
          banner={banner}
          activeTabId={activeTabId}
          onCardClick={onTabChange}
        />
      }
      {shouldShowHeaderAndTabs &&
        <ScoreboardTabs tabs={tabs} activeTabId={activeTabId} onTabChange={onTabChange} />
      }
      <div className={classes.tabContent}>
        {TabComponent &&
          <TabComponent 
            houses={houses} 
            classesList={classesList}
          />
        }
      </div>
      <BannerButtom />
    </div>
  );
};

export default Scoreboard;
